import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function ArrowsRightIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M26.6305 11.8333L22.2631 7.66666L17.8956 3.5L13.5341 7.66666L17.8956 11.8333L22.2631 16L17.8956 20.1666L13.5341 24.3334L17.8956 28.5L22.2631 24.3334L26.6305 20.1666L30.998 16L26.6305 11.8333Z"
        fill="currentColor"
      />
      <path
        d="M15.6098 13.212L12.6881 10.4247L9.76641 7.64306L6.84473 10.4247L9.76641 13.212L12.6881 15.9994L9.76641 18.7867L6.84473 21.5741L9.76641 24.3557L12.6881 21.5741L15.6098 18.7867L18.5255 15.9994L15.6098 13.212Z"
        fill="currentColor"
        fillOpacity="0.75"
      />
      <path
        d="M6.8012 14.155L4.86748 12.3102L2.93374 10.4653L1 12.3102L2.93374 14.155L4.86748 15.9999L2.93374 17.8446L1 19.6895L2.93374 21.5343L4.86748 19.6895L6.8012 17.8446L8.73494 15.9999L6.8012 14.155Z"
        fill="currentColor"
        fillOpacity="0.5"
      />
    </BaseIcon>
  );
}
